$(document).ready(function () {
    //$(".txt-producto-bolsa").hide()

    $(".add-item-bag").on('click', function (e) {
        e.preventDefault()
        let slug = $(this).data('slug')
        let data = new FormData()
        data.append('slug', slug)
        $("#div_loading").addClass("loading-almadia");
        sendData('add-bag-item', data)
    })


    $(document).on('click', '.delete-bag-item', function (e) {
        e.preventDefault()
        let slug = $(this).data('slug')
        let data = new FormData()
        data.append('slug', slug)
        swal.fire({
            title: "¿Estas seguro?",
            text: "Tu artículo sera eliminado",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Si, eliminar!',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {
                $("#div_loading").addClass("loading-almadia");
                sendData('delete-bag-item', data)
            }
        })

    })
    $(document).on('click', '#empty-bag', function (e) {
        e.preventDefault()
        swal.fire({
            title: "¿Estas seguro?",
            text: "Tus artículos serán eliminados",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Si, eliminar!',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {
                $("#div_loading").addClass("loading-almadia");
                sendData('empty-cart')
            }
        })
    })

    window.updateItemCart = function (evt, input, index) {
        let code = (evt.which) ? evt.which : evt.keyCode
        let inputValue = evt.target.value + String.fromCharCode(code)
        let quantity = parseInt(input.value);
        let validaKey = valideKey(code)
        if (validaKey) {
            let valida_number = validaNumber(inputValue,index)
            if (valida_number) {
                let itemId = input.getAttribute('data-row');
                updateItem(quantity, itemId)
                console.log("evento 1")
            }
        } else {
            alertError('Solo se aceptan valores numéricos')
        }
    }


    window.eventUpdateItemCart = function (event, input) {
        var quantity = parseInt(input.value);

        // Verificamos si el valor es un número válido y mayor que cero
        if (!isNaN(quantity) && quantity >= 1 && quantity <= 99) {
            // Haces lo que necesites con el valor válido, por ejemplo, puedes enviarlo al servidor
            var itemId = input.getAttribute('data-row');
            updateItem(quantity, itemId)
        } else {
            // Si el valor no es válido, puedes mostrar un mensaje de error o realizar otra acción
            console.log('Cantidad no válida');
        }

    }

    window.eventUpdateItemCart1 = function (event, input) {
        var quantity = parseInt(input.value);
        if (!isNaN(quantity) && quantity >= 1 && quantity <= 99) {
            var itemId = input.getAttribute('data-row');
            updateItem(quantity, itemId)
        } else {
            //alertErrorAlmadia("Valor no valido")
        }

    }

    function updateItem(quantity, itemId) {
        let data = new FormData()
        data.append('itemId', itemId)
        data.append('quantity', quantity)
        $.ajax({
            url: "/update-cart-item",
            type: "post",
            data: data,
            processData: false,
            contentType: false,
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            success: function (response) {
                //document.getElementById('almadia_shopping_cart_cart').innerHTML = response;

                document.getElementById('almadia_shopping_cart_cart').innerHTML = response.cartView;
                document.getElementById('almadia_shopping_cart_total').innerHTML = response.cartResumen;
                document.getElementById('almadia_shopping_cart_gift').innerHTML = response.cartGift;

                setTimeout(function () {
                    $("#div_loading").removeClass("loading-almadia");
                }, 3000)
            },
            error: function (jqXHR, xhr, status,) {

            }
        })
    }

    function sendData(route, data) {
        $.ajax({
            url: window.location.origin + '/' + route,
            type: "post",
            data: data,
            processData: false,
            contentType: false,
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            success: function (response) {
                console.log(response)
                setTimeout(function () {
                    $("#div_loading").removeClass("loading-almadia");

                    if (response.type === "successEmptyCart") {
                        showEmptyBag(response)

                    } else if (response.type === "success") {
                        if (response.num_items === 0) {
                            showEmptyBag(response)
                        } else {
                            alertSuccessAlmadia(response.msg)
                            $(".badge-bolsa").html(response.num_items)
                            $("#div_icon").addClass("mb-icon");
                            let icon = "<span class='txt-producto-bolsa'>Tu producto se añadió a la bolsa</span> " +
                                "<img class='icon-bolsa-feliz-menu' src=' " +
                                window.location.origin + "/images/icono/bolsa/bolsa4.png" + "' alt='agregado-web'>";
                            document.getElementById('div_icon').innerHTML = icon;
                            document.getElementById('detail_bag').innerHTML = response.view;
                        }
                    } else {
                        alertErrorAlmadia(response.msg)
                    }
                }, 3000)
            },
            error: function (jqXHR, xhr, status,) {

            }
        })
    }

    function valideKey(code) {
        if (code == 8) {
            return true;
        } else if (code >= 48 && code <= 57) {
            return true;
        } else {
            return false;
        }
    }

    function validaNumber(inputValue,index) {
        let value = parseInt(inputValue)
        if (value > 0) {
            return true
        }
        $("#input-inx-"+index).val(1)
        alertError('La cantidad debe ser mayor a 0')
    }

    function showEmptyBag(response) {

        /*En caso de que el número de ítems sea 0 y la ruta sea 'carrito/pagar',
         se realiza una redirección a la página de inicio ('home').*/
        if (window.location.pathname === "/carrito/pagar") {
            window.location.href = window.location.protocol + '//' + window.location.hostname;
        }
        alertSuccessAlmadia(response.msg);
        $(".badge-bolsa").html(response.num_items)
        $("#div_icon").removeClass("mb-icon");
        let view = "<span class='d-bag-t'> <img class='img-d-bag' src=" +
            window.location.origin + "/images/icono/bolsa/bolsa4.png" +
            " alt='agregado-web'> Tu bolsa está vacía </span>";
        document.getElementById('div_icon').innerHTML = "";
        document.getElementById('detail_bag').innerHTML = view;
    }

    $('#gifts').on('click', function () {
        if ($(this).is(':checked')) {
            $('#collapseExample').collapse('show')
        } else {
            $('#collapseExample').collapse('hide')
        }
    });
})




